export default "__VITE_ASSET__BreizrED__"